export let VIEW_MODES = /*#__PURE__*/function (VIEW_MODES) {
  VIEW_MODES["SITE"] = "site";
  VIEW_MODES["EDITOR"] = "editor";
  VIEW_MODES["PREVIEW"] = "preview";
  VIEW_MODES["DASHBOARD"] = "dashboard";
  VIEW_MODES["STANDALONE"] = "standalone";
  return VIEW_MODES;
}({});
//# sourceMappingURL=view-modes.js.map